// extracted by mini-css-extract-plugin
export var content = "_bj-3";
export var list = "_bj-4";
export var settingsContent = "_bj-7";
export var settingsPanel = "_bj-8";
export var state = "_bj-6";
export var triggerBadge = "_bj-2";
export var triggerButton = "_bj-1";
export var triggerShell = "_bj-0";
export var unreadDot = "_bj-5";